var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/store",
        pageTitle: "Store",
        hasFab: _vm.can("Manage inventory") && _vm.getTab?.createable,
        fabClasses: "store-fab",
        tabs: true,
        cart: _vm.productsInCart.length
          ? _vm.productsInCart.map((e) => e.quantity).reduce((a, b) => a + b)
          : null,
      },
      on: {
        fabAction: function ($event) {
          _vm.manageProduct = {}
        },
        showCart: function ($event) {
          _vm.$refs.shoppingCart.dialog = true
        },
        pageSearch: function ($event) {
          _vm.search = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  staticClass: "pr-5 custom-tabs",
                  attrs: {
                    "center-active": "",
                    "background-color": "transparent",
                    height: "42px",
                  },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                _vm._l(_vm.tabList, function (tab) {
                  return _c(
                    "v-tab",
                    {
                      key: tab.slug,
                      staticClass: "no-link",
                      attrs: { href: `/store/${tab.slug}` },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass:
                            "no-link flex align-center justify-center min-h-full",
                          attrs: {
                            href: `/store/${tab.slug}${
                              _vm.client ? `/${_vm.client.id}` : ""
                            }`,
                            "preserve-state": "",
                            only: ["products"],
                          },
                        },
                        [_vm._v(_vm._s(tab.title))]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.can("Work")
        ? _c("ShoppingCart", {
            ref: "shoppingCart",
            attrs: {
              id: "shoppingCart",
              productsInCart: _vm.productsInCart,
              client: _vm.client,
              selectedTab: _vm.selectedTab,
              errors: _vm.errors,
              taxRate: _vm.taxRate,
              guestCheckout: _vm.guestCheckout,
            },
            on: {
              increment: _vm.increment,
              decrement: _vm.decrement,
              removeFromCart: _vm.removeFromCart,
              loadUnpaidAssessments: _vm.loadUnpaidAssessments,
              success: function ($event) {
                _vm.$refs.layout.showMessage = true
              },
              reset: _vm.closeCart,
              reload: function ($event) {
                return _vm.reload($event)
              },
              createInlinePrice: function ($event) {
                return _vm.setupInlinePrice($event)
              },
              guestCheckout: function ($event) {
                ;[
                  (_vm.guestCheckout = $event),
                  _vm.closeCart(),
                  _vm.successData ? (_vm.viewReceipt = true) : null,
                ]
              },
              locationSelect: function ($event) {
                ;[
                  (_vm.$refs.layout.locationRedirect = `store/frequent/${$event.id}`),
                  $event.locations.length == 1
                    ? _vm.$refs.layout.updateSelectedLocation(
                        $event.locations[0]
                      )
                    : [
                        (_vm.$refs.layout.locationSelect = true),
                        (_vm.$refs.layout.studentLocations = $event.locations),
                      ],
                ]
              },
              tagPrices: function ($event) {
                return _vm.tagPrices($event)
              },
              clearPromo: function ($event) {
                return _vm.clearPromo($event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticStyle: { height: "100%" },
          attrs: { value: _vm.selectedTab, touchless: "" },
        },
        _vm._l(_vm.tabList, function (tab) {
          return _c(
            "div",
            { key: tab.slug },
            [
              _vm.selectedTab == `/store/${tab.slug}`
                ? _c(
                    "v-tab-item",
                    {
                      attrs: { value: `/store/${tab.slug}`, transition: false },
                    },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "animate__animated animate__fadeIn",
                          attrs: { fluid: "" },
                        },
                        [
                          _c("v-data-iterator", {
                            attrs: {
                              items: _vm.getProducts,
                              search: _vm.search,
                              "item-key": "id",
                              "hide-default-footer": "",
                              "mobile-breakpoint": "0",
                              "disable-pagination": "",
                              groupBy:
                                _vm.selectedTab == "/store/programs"
                                  ? "program_id"
                                  : null,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm.selectedTab !== "/store/programs"
                                        ? _c("ProductList", {
                                            key: props.items.length,
                                            attrs: {
                                              products: props.items,
                                              listView: _vm.listView,
                                            },
                                            on: {
                                              addProductToCart: function (
                                                $event
                                              ) {
                                                return _vm.addProductToCart(
                                                  $event
                                                )
                                              },
                                              manageProduct: function ($event) {
                                                _vm.manageProduct = $event
                                              },
                                              success: function ($event) {
                                                _vm.$refs.layout.showMessage = true
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTab == "/store/programs"
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              props.groupedItems,
                                              function (data, idx) {
                                                return _c(
                                                  "div",
                                                  { key: idx },
                                                  [
                                                    !_vm.$root.loading
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex ma-5",
                                                          },
                                                          [
                                                            _c(
                                                              "v-avatar",
                                                              {
                                                                attrs: {
                                                                  size: "96",
                                                                  tile: "",
                                                                },
                                                              },
                                                              [
                                                                _c("v-img", {
                                                                  staticClass:
                                                                    "soli-round",
                                                                  attrs: {
                                                                    src: _vm.getProgramImage(
                                                                      data.name
                                                                    ),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                            _c("v-card-title", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.programs.find(
                                                                    (e) =>
                                                                      e.id ==
                                                                      data.name
                                                                  )?.title
                                                                )
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("ProductList", {
                                                      attrs: {
                                                        products: data.items,
                                                        divider: _vm.listView,
                                                        listView: _vm.listView,
                                                      },
                                                      on: {
                                                        addProductToCart:
                                                          function ($event) {
                                                            return _vm.addProductToCart(
                                                              $event
                                                            )
                                                          },
                                                        manageProduct:
                                                          function ($event) {
                                                            _vm.manageProduct =
                                                              $event
                                                          },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.viewReceipt !== null
        ? _c(
            "div",
            { staticClass: "soli-round" },
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    fullscreen: _vm.$vuetify.breakpoint.xs ? true : false,
                    "content-class": _vm.$vuetify.breakpoint.xs
                      ? ""
                      : "soli-round",
                    transition: _vm.$vuetify.breakpoint.smAndDown
                      ? "dialog-bottom-transition"
                      : "dialog-transition",
                    "max-width": "600px",
                  },
                  model: {
                    value: _vm.viewReceipt,
                    callback: function ($$v) {
                      _vm.viewReceipt = $$v
                    },
                    expression: "viewReceipt",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _vm.$refs.shoppingCart
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-5 mr-15 soli-close soli-round",
                              attrs: {
                                outlined: "",
                                "x-small": "",
                                disabled:
                                  !_vm.$refs.shoppingCart.selectedClient,
                                href: _vm.$refs.shoppingCart.selectedClient
                                  ? `/profile/${_vm.$refs.shoppingCart.selectedClient.id}/account`
                                  : null,
                              },
                              on: {
                                click: function ($event) {
                                  ;[(_vm.viewReceipt = false)]
                                },
                              },
                            },
                            [_vm._v("View Profile")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "ma-3 soli-close soli-grey soli-text-shadow",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              ;[
                                (_vm.viewReceipt = false),
                                (_vm.$refs.shoppingCart.selectedClient = null),
                                (_vm.$page.props.successData = null),
                              ]
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-card-title", [_vm._v("Thank you!")]),
                      _vm._v(" "),
                      _c("v-card-subtitle", [_vm._v("Here's your receipt")]),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { staticClass: "pt-0" },
                        [
                          _vm.successData
                            ? _c(
                                "v-list",
                                [
                                  _c("v-list-item", [
                                    _vm._v(
                                      "\n                            Email: " +
                                        _vm._s(_vm.successData.customer_email) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            Amount:\n                            " +
                                        _vm._s(
                                          _vm.formatUnitAmount(
                                            _vm.successData.amount
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            Payment:\n                            " +
                                        _vm._s(_vm.successData.last4) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                  ]),
                                  _vm._v(" "),
                                  _vm.successData.giftCards?.length
                                    ? _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "soli-grey font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Gift Cards:\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.successData.giftCards,
                                                function (gift) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: gift.id,
                                                      staticClass:
                                                        "flex-col align-start mb-2",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                                        Gift Amount:\n                                        " +
                                                            _vm._s(
                                                              _vm.formatUnitAmount(
                                                                gift.amount
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "Code: " +
                                                            _vm._s(gift.code)
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLessonMembershipRequired
        ? _c("SoliChoice", {
            attrs: {
              title: "Lesson Membership Required",
              subtitle:
                "This membership requires an additional lesson membership. Please add one before completing this purchase.",
              button1: "Okay",
              permanent: "",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.showLessonMembershipRequired = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createInlinePrice
        ? _c("SoliForm", {
            ref: "inlinePriceForm",
            attrs: {
              title: "Adjust Price",
              choices: "",
              permanent: "",
              persistent: "",
              textSubtitle: _vm.createInlinePrice.price.interval
                ? "This product is a membership. Changing the price will affect future billing."
                : "This product is a one-time purchase. Changing the price will not affect future billing.",
              saveChanges: !_vm.$refs.inlinePriceText?.$refs.input?.hasError,
            },
            on: {
              submit: function ($event) {
                return _vm.confirmInlinePrice(_vm.createInlinePrice)
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.createInlinePrice = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-4" },
                        [
                          _c("v-currency-field", {
                            ref: "inlinePriceText",
                            staticClass: "soli-round",
                            attrs: {
                              rules: [
                                (val) => !!val || "Price is required",
                                (val) =>
                                  val * 100 !==
                                    (
                                      _vm.createInlinePrice.prices.find(
                                        (e) =>
                                          e.id ==
                                          _vm.createInlinePrice.price
                                            .originalPrice
                                      ) ?? _vm.createInlinePrice.price
                                    ).unit_amount || "Price must be different",
                                (val) =>
                                  String(val).replace(/,/g, "") >= 0 ||
                                  "Price must be greater than or equal to $0.00",
                                (val) =>
                                  String(val).replace(/,/g, "") <= 500 ||
                                  "Price must be not be greater than $500.00",
                              ],
                              outlined: "",
                              dense: "",
                              label: "Price",
                              "error-message": "errors.amount",
                              "prepend-inner-icon": "attach_money",
                              "validate-on-blur": "",
                              allowNegative: false,
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.inlinePrice.unit_amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.inlinePrice, "unit_amount", $$v)
                              },
                              expression: "inlinePrice.unit_amount",
                            },
                          }),
                          _vm._v(" "),
                          _vm.inlinePrice.unit_amount === 0 &&
                          _vm.inlinePrice.interval
                            ? _c("PriceCouponDuration", {
                                model: {
                                  value: _vm.inlinePrice.coupon_duration,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.inlinePrice,
                                      "coupon_duration",
                                      $$v
                                    )
                                  },
                                  expression: "inlinePrice.coupon_duration",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("PriceTags", {
                            ref: "priceTags",
                            model: {
                              value: _vm.inlinePrice.tags,
                              callback: function ($$v) {
                                _vm.$set(_vm.inlinePrice, "tags", $$v)
                              },
                              expression: "inlinePrice.tags",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              6098900
            ),
            model: {
              value: _vm.validInlinePrice,
              callback: function ($$v) {
                _vm.validInlinePrice = $$v
              },
              expression: "validInlinePrice",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.manageProduct
        ? _c("ManageProduct", {
            attrs: {
              product: _vm.manageProduct,
              category: _vm.getTab,
              errors: _vm.errors,
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.manageProduct = null))
              },
              success: function ($event) {
                ;[(_vm.$refs.layout.showMessage = true), _vm.closeCart()]
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }